/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneAusilioUpdateDTO
 */
export interface DeambulazioneAusilioUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneAusilioUpdateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneAusilioUpdateDTO interface.
 */
export function instanceOfDeambulazioneAusilioUpdateDTO(value: object): value is DeambulazioneAusilioUpdateDTO {
    return true;
}

export function DeambulazioneAusilioUpdateDTOFromJSON(json: any): DeambulazioneAusilioUpdateDTO {
    return DeambulazioneAusilioUpdateDTOFromJSONTyped(json, false);
}

export function DeambulazioneAusilioUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneAusilioUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneAusilioUpdateDTOToJSON(value?: DeambulazioneAusilioUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

